import useAsyncData from 'src/utils/useAsyncData';
import { getFormDataAPI } from 'src/serverApi/applications';

const useApplicationAllowedBanks = () => {
  const [
    fetchFormData,
    wasFormDataFetched,
    isFormDataLoading,
    formData,
    formDataError,
  ] = useAsyncData(getFormDataAPI);

  return {
    fetchFormData,
    wasFormDataFetched,
    isFormDataLoading,
    formData,
    formDataError,
  };
};

export default useApplicationAllowedBanks;
